export const computeIBANFromCzechBankAccount = (
  prefix: string,
  number: string,
  bankCode: string,
): string => {
  // Preprocess the numbers
  const formattedPrefix = prefix.padStart(6, '0')
  const formattedNumber = number.padStart(10, '0')
  const formattedBank = bankCode.padStart(4, '0')

  // Calculate the check sum
  const buf = `${formattedBank}${formattedPrefix}${formattedNumber}123500`
  let index = 0
  let dividend: string
  let pz = -1;
  while (index <= buf.length) {
    if (pz < 0) {
      dividend = buf.substring(index, Math.min(index + 9, buf.length))
      index += 9
    } else if (pz >= 0 && pz <= 9) {
      dividend = `${pz}${buf.substring(index, Math.min(index + 8, buf.length))}`
      index += 8
    } else {
      dividend = `${pz}${buf.substring(index, Math.min(index + 7, buf.length))}`
      index += 7
    }
    pz = parseInt(dividend) % 97
  }
  pz = 98 - pz

  // Assign the checksum
  const checksum = pz.toString().padStart(2, '0')

  // Build the IBAN number
  return `CZ${checksum}${formattedBank}${formattedPrefix}${formattedNumber}`
}
